import { PageHeading, UserRoleHeading } from '@/components/Layout/Parts';

import FreelancersInvoicesApprovalTable from './components/FreelancersInvoicesApprovalTable';

const FreelancersInvoicesApproval = () => {
  return (
    <>
      <UserRoleHeading />
      <PageHeading>Invoices Approvals</PageHeading>
      <FreelancersInvoicesApprovalTable />
    </>
  );
};

export default FreelancersInvoicesApproval;
